module.exports = __webpack_public_path__ + "cb48fad625b92f57bf2c380a9806ed95.svg";